import React from 'react'
import { ComponentConfig, Slot } from '@puckeditor/core'
import { ColorField } from 'breaktime-theme/src/puck/fields/ColorField'
import {
  TypographyProps,
  fontFamilyField,
  fontFamilyFallbackField,
  textTransformField,
  fontWeightOptions,
  applyTypography,
  FontWeight,
} from 'breaktime-theme/src/puck/fields/StyleFields'
import * as styles from './PollQuestion.module.scss'

export type PollQuestionProps = {
  id?: string
  text?: string
  headerContent: Slot
  textAnswered?: string
  userSelectionResultBarColor: string
  otherSelectionsResultBarColor: string
  answers: Slot
  fontFamily?: TypographyProps['fontFamily']
  fontFamilyFallback?: TypographyProps['fontFamilyFallback']
  textTransform?: TypographyProps['textTransform']
  fontSize?: string
  fontWeight?: FontWeight
}

export const POLL_QUESTION_DEFAULT_PROPS: PollQuestionProps = {
  text: 'New Question',
  headerContent: [],
  textAnswered: '',
  userSelectionResultBarColor: '#4C3371',
  otherSelectionsResultBarColor: '#6D6D6D',
  answers: [],
}

export const PuckPollQuestion: ComponentConfig<PollQuestionProps> = {
  label: 'Poll Question',
  defaultProps: POLL_QUESTION_DEFAULT_PROPS,
  fields: {
    text: { type: 'text' as const, label: 'Question Text' },
    headerContent: {
      type: 'slot' as const,
      disallow: [
        'PollContainer',
        'PollQuestion',
        'PollAnswer',
        'PollProduct',
        'PollProductPanel',
        'PollDropdownButton',
        'PollNextQuestionButton',
      ],
    },
    textAnswered: {
      type: 'text' as const,
      label: 'Question Result Text (Sponsored only)',
    },
    userSelectionResultBarColor: {
      type: 'custom' as const,
      label: 'User Selection Result Bar Color',
      render: (props: any) => <ColorField {...props} />,
    },
    otherSelectionsResultBarColor: {
      type: 'custom' as const,
      label: 'Other Selections Result Bar Color',
      render: (props: any) => <ColorField {...props} />,
    },
    answers: { type: 'slot' as const, allow: ['PollAnswer'] },
    fontFamily: fontFamilyField,
    fontFamilyFallback: fontFamilyFallbackField,
    textTransform: textTransformField,
    fontSize: { type: 'text' as const, label: 'Font Size', placeholder: '24px' },
    fontWeight: { type: 'select' as const, label: 'Font Weight', options: fontWeightOptions },
  },
  render: ({
    text,
    headerContent: HeaderContent,
    answers: Answers,
    fontFamily,
    fontFamilyFallback,
    textTransform,
    fontSize,
    fontWeight,
  }) => (
    <div
      className="poll-view-container no-skip-button"
      style={{ marginBottom: 24 }}
    >
      <HeaderContent
        minEmptyHeight={36}
        className={`${styles.pollQuestionHeaderSlot} poll-item-image`}
        disallow={[
          'PollContainer',
          'PollQuestion',
          'PollAnswer',
          'PollProduct',
          'PollProductPanel',
          'PollDropdownButton',
          'PollNextQuestionButton',
        ]}
      />
      <h2
        className="poll-slide-title poll-question-headline"
        style={{
          ...applyTypography({ fontFamily, fontFamilyFallback, textTransform }),
          ...(fontSize ? { fontSize } : {}),
          ...(fontWeight ? { fontWeight: Number(fontWeight) || undefined } : {}),
        }}
        dangerouslySetInnerHTML={{ __html: text || '' }}
      />
      <div className="poll-view is-active">
        <div className="poll-question-container">
          <div className="poll-question-list">
            <ul>
              <Answers
                style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
                allow={['PollAnswer']}
                className={styles.pollQuestionAnswersSlot}
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  ),
}
